import { useEffect, useRef, useState } from "react";

const UseInView = (opts = {}) => {
  const ref = useRef(null); const [vis, setVis] = useState(false);
  useEffect(() => { const el = ref.current; if (!el) return; const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVis(true); obs.unobserve(el); } }, { threshold: 0.12, ...opts }); obs.observe(el); return () => obs.disconnect();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); return [ref, vis];
};

export default UseInView;